import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Button,
  Divider,
  LinearProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { ICOBaseURL } from "src/ApiConfig/ApiConfig";
import { calculateTimeLeft, HandleTrim } from "src/utils";

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 12,
    borderRadius: 18,
  },
  colorPrimary: {
    backgroundColor: "#424242",
  },
  bar: {
    background:
      "linear-gradient(93.14deg, #FFB000 -20.75%, #FF564D 11.84%, #FF0098 53.76%, #5D00C1 102.96%)",
  },
}))(LinearProgress);
const useStyles = makeStyles((theme) => ({
  bannerbox: {
    // padding: "107px 0px 130px",
    // backgroundImage: "url(images/backimg.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    zIndex: "1",
    overflow: "hidden",
    position: "relative",
    // [theme.breakpoints.down("md")]: {
    //   padding: "100px 0px",
    // },
    // [theme.breakpoints.down("xs")]: {
    //   padding: "70px 0px 100px",
    // },
    "&::after": {
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      content: "''",
      zIndex: "1",
      position: "absolute",
      opacity: "0.1",
      //   background:
      //     "linear-gradient(89.75deg, rgb(228 136 0 / 22%) 0.21%, rgb(110 10 145 / 37%) 36.51%, rgb(157 92 212 / 25%) 99.77%, rgb(0 0 0) 99.78%, rgb(180 156 156 / 21%) 99.78%)",
    },
    "& h1": {
      fontSize: "45px",
      fontWeight: "700",
      lineHeight: "63px",
      width: "100%",
      maxWidth: "701px",
      letterSpacing: "1.6px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
      "@media(max-width:767px)": {
        fontSize: "25px !important",
        lineHeight: "40px",
      },
    },
    "& h4": {
      width: "100%",
      margin: "25px 0px 35px",
      maxWidth: "607px",
      fontWeight: "400",
      fontSize: "20px",
      lineHeight: "31px",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
    "& p": {
      color: "rgba(255, 255, 255, 0.6)",
      fontWeight: "300",
      textAlign: "center",
      marginTop: "10px",
    },
    "& .timebox": {
      background: "rgba(255, 255, 255, 0.05)",
      borderRadius: "12px",
      padding: "10px",
      textAlign: "center",
      paddingTop: "15px",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  leftbox: {
    width: "100%",
    margin: "0 auto",
    background: "rgba(0, 0, 0, 0.25)",
    border: "2px solid #4b2828",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    position: "relative",
    borderRadius: "12px",
    "&:before": {
      top: "0px",
      left: "0px",
      width: "100%",
      height: "100%",
      zIndex: "-1",
      content: "' '",
      position: "absolute",
      backdropFilter: "blur(12.5px)",
      opacity: "0.3",
      background: "rgba(255,255,255, 0.17)",
    },
    "& .boxcontrol": {
      padding: "45px 50px",
      [theme.breakpoints.down("md")]: {
        padding: "45px 30px",
      },
      [theme.breakpoints.down("xs")]: {
        padding: "45px 15px",
      },
    },
  },
  listsale: {
    "& p": {
      whiteSpace: "pre",
      // textOverflow: "ellipsis",
      // overflow: "hidden",
      width: "calc(100% - 5px)",
      maxWidth: "145px",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
    },
  },
}));
const timeData = [
  {
    time: "30",
    day: "Days",
  },
  {
    time: "23",
    day: "Hours",
  },
  {
    time: "14",
    day: "Minutes",
  },
  {
    time: "32",
    day: "Seconds",
  },
];
function Timer() {
  const classes = useStyles();
  const history = useHistory();
  //   useEffect(() => {
  //     /**
  //      * 3D Software ocean effect with Canvas2D
  //      * You can change properties under comment "Effect properties"
  //      */

  //     // Init Context
  //     let c = document.createElement("canvas").getContext("2d");
  //     let postctx = document
  //       .getElementById("App-header")
  //       .appendChild(document.createElement("canvas"))
  //       .getContext("2d");
  //     let canvas = c.canvas;
  //     let vertices = [];

  //     // Effect Properties
  //     let vertexCount = 31000;
  //     let vertexSize = 3;
  //     let oceanWidth = 424;
  //     let oceanHeight = 20;
  //     let gridSize = 8;
  //     let waveSize = 114;
  //     let perspective = 150;

  //     // Common variables
  //     let depth = (vertexCount / oceanWidth) * gridSize;
  //     let frame = 0;
  //     let { sin, cos, tan, PI } = Math;

  //     // Render loop
  //     let loop = () => {
  //       let rad = (sin(frame / 100) * PI) / 20;
  //       let rad2 = (sin(frame / 50) * PI) / 10;
  //       frame++;
  //       if (
  //         postctx.canvas.width !== postctx.canvas.offsetWidth ||
  //         postctx.canvas.height !== postctx.canvas.offsetHeight
  //       ) {
  //         postctx.canvas.width = canvas.width = postctx.canvas.offsetWidth;
  //         postctx.canvas.height = canvas.height = postctx.canvas.offsetHeight;
  //       }

  //       // c.fillStyle = `hsl(200deg, 100%, 2%)`;
  //       c.fillStyle = `#000`;
  //       c.fillRect(0, 0, canvas.width, canvas.height);
  //       c.save();
  //       c.translate(canvas.width / 2, canvas.height / 2);

  //       c.beginPath();
  //       vertices.forEach((vertex, i) => {
  //         let ni = i + oceanWidth;
  //         let x = vertex[0] - (frame % (gridSize * 2));
  //         let z =
  //           vertex[2] -
  //           ((frame * 2) % gridSize) +
  //           (i % 2 === 0 ? gridSize / 2 : 0);
  //         let wave =
  //           cos(frame / 45 + x / 50) -
  //           sin(frame / 20 + z / 50) +
  //           sin(frame / 30 + (z * x) / 10000);
  //         let y = vertex[1] + wave * waveSize;
  //         let a = Math.max(0, 1 - Math.sqrt(x ** 2 + z ** 2) / depth);
  //         let tx, ty, tz;

  //         y -= oceanHeight;

  //         // Transformation variables
  //         tx = x;
  //         ty = y;
  //         tz = z;

  //         // Rotation Y
  //         tx = x * cos(rad) + z * sin(rad);
  //         tz = -x * sin(rad) + z * cos(rad);

  //         x = tx;
  //         y = ty;
  //         z = tz;

  //         // Rotation Z
  //         tx = x * cos(rad) - y * sin(rad);
  //         ty = x * sin(rad) + y * cos(rad);

  //         x = tx;
  //         y = ty;
  //         z = tz;

  //         // Rotation X

  //         ty = y * cos(rad2) - z * sin(rad2);
  //         tz = y * sin(rad2) + z * cos(rad2);

  //         x = tx;
  //         y = ty;
  //         z = tz;

  //         x /= z / perspective;
  //         y /= z / perspective;

  //         if (a < 0.01) return;
  //         if (z < 0) return;

  //         c.globalAlpha = a;
  //         c.fillStyle = `hsl(${2 + wave * 20}deg, 100%, 50%)`;
  //         // c.fillStyle = `#FF00CD`;
  //         c.fillRect(
  //           x - (a * vertexSize) / 2,
  //           y - (a * vertexSize) / 2,
  //           a * vertexSize,
  //           a * vertexSize
  //         );
  //         c.globalAlpha = 1;
  //       });
  //       c.restore();

  //       // Post-processing
  //       postctx.drawImage(canvas, 0, 0);

  //       postctx.globalCompositeOperation = "screen";
  //       postctx.filter = "blur(16px)";
  //       postctx.drawImage(canvas, 0, 0);
  //       postctx.filter = "blur(0)";
  //       postctx.globalCompositeOperation = "source-over";

  //       requestAnimationFrame(loop);
  //     };

  //     // Generating dots
  //     for (let i = 0; i < vertexCount; i++) {
  //       let x = i % oceanWidth;
  //       let y = 0;
  //       let z = (i / oceanWidth) >> 0;
  //       let offset = oceanWidth / 2;
  //       vertices.push([(-offset + x) * gridSize, y * gridSize, z * gridSize]);
  //     }

  //     loop();
  //   }, []);

  const tokenCheck = window.sessionStorage.getItem("token");
  const [liveSaleList, setLiveSaleList] = useState([]);
  const [classcheck, setClasscheck] = useState([]);
  const [livesale, setLivesale] = useState("");
  const [slidervalue, setSlidervalue] = useState();
  const [closeTimeLeft, setCloseTimeLeft] = useState([]);
  const timeValue = moment(livesale?.saleUptodate).unix();

  const getSaleListHandler = async () => {
    try {
      const res = await axios({
        method: "GET",
        url: `${ICOBaseURL}/wallet/get-sale-list`,
      });

      if (res.data.status === 200) {
        setLiveSaleList(res.data.data.fullList);
        setLivesale(res.data.data.enabled_sale);
        const index = res.data.data.fullList.findIndex(
          (data) => data?.icoStatus === "ENABLE"
        );
        const myData = (index + 1) * 25;
        setSlidervalue(myData);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getSaleListHandler();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCloseTimeLeft(
        calculateTimeLeft(
          new Date(parseInt(moment(livesale?.saleUptodate).unix()) * 1000)
        )
      );
    }, 1000);
    return () => clearTimeout(timer);
  });

  return (
    <Box className={classes.bannerbox}>
      <div id="App-header">
        <Container className="mainBoxBanner">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              <Box className={classes.leftbox}>
                <Box className="boxcontrol">
                  <Typography variant="h5" align="center">
                    {livesale?.planName
                      ? HandleTrim(livesale?.planName)
                      : "ICO"}{" "}
                    IS LIVE NOW
                  </Typography>
                  <Box mt={2}>
                    <Grid container spacing={4}>
                      <Grid item lg={3} md={3} sm={3} xs={6}>
                        <Box className="timebox">
                          <Typography variant="h5">
                            {closeTimeLeft?.days ? closeTimeLeft?.days : 0}
                          </Typography>
                        </Box>
                        <Typography variant="body2">Days</Typography>
                      </Grid>
                      <Grid item lg={3} md={3} sm={3} xs={6}>
                        <Box className="timebox">
                          <Typography variant="h5">
                            {closeTimeLeft?.hours ? closeTimeLeft?.hours : 0}
                          </Typography>
                        </Box>
                        <Typography variant="body2">Hours</Typography>
                      </Grid>
                      <Grid item lg={3} md={3} sm={3} xs={6}>
                        <Box className="timebox">
                          <Typography variant="h5">
                            {closeTimeLeft?.minutes
                              ? closeTimeLeft?.minutes
                              : 0}
                          </Typography>
                        </Box>
                        <Typography variant="body2">Minutes</Typography>
                      </Grid>
                      <Grid item lg={3} md={3} sm={3} xs={6}>
                        <Box className="timebox">
                          <Typography variant="h5">
                            {closeTimeLeft?.seconds
                              ? closeTimeLeft?.seconds
                              : 0}
                          </Typography>
                        </Box>
                        <Typography variant="body2">Seconds</Typography>
                      </Grid>
                    </Grid>
                    <Box mt={2} mb={2}>
                      <Divider />
                    </Box>
                    <Typography variant="h5" align="center">
                      Sale Tranche
                    </Typography>
                    <Box mt={2}>
                      <Box className="bordersign">
                        <BorderLinearProgress
                          variant="determinate"
                          value={slidervalue}
                        />
                        <Grid container spacing={2}>
                          {liveSaleList &&
                            liveSaleList?.map((data, i) => {
                              return (
                                <Grid item lg={3} md={3} sm={3} xs={3}>
                                  <Box className={classes.listsale}>
                                    <Typography variant="body2">
                                      {HandleTrim(data?.planName).split(" ")[0]}
                                      {/* {data?.planName.length > 15 && "..."} */}
                                    </Typography>
                                  </Box>
                                </Grid>
                              );
                            })}
                        </Grid>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        mt={3}
                        style={{ position: "relative", zIndex: "999" }}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          href="https://vesting.fieres.io/buy-fiero"
                          target="_blank"
                        >
                          Purchase Fiero
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </div>
    </Box>
  );
}

export default Timer;
